const TRUNCATE_LENGTH = 27;
export const truncateFileName = (name: string) => {
  if (name.length <= TRUNCATE_LENGTH) {
    return { name, truncated: false };
  }

  return {
    name: `${name.slice(0, TRUNCATE_LENGTH / 2)}...${name.slice(
      Math.floor(name.length - TRUNCATE_LENGTH / 2),
      name.length
    )}`,
    truncated: true,
  };
};

export const fileSizeInKiloBytes = (kiloBytes: number) => {
  return 1024 * kiloBytes;
};
export const fileSizeInMegaBytes = (megaBytes: number) => {
  return fileSizeInKiloBytes(megaBytes) * 1024;
};
export const fileSizeInGigaBytes = (gigaBytes: number) => {
  return fileSizeInMegaBytes(gigaBytes) * 1024;
};

export const convertBytesToKiloBytes = (bytes: number) => {
  const sizeInKB = bytes / 1024;
  return sizeInKB;
};

export const convertBytesToMegaBytes = (bytes: number) => {
  const sizeInMB = convertBytesToKiloBytes(bytes) / 1024;
  return sizeInMB;
};

export const convertBytesToGigaBytes = (bytes: number) => {
  const sizeInGB = convertBytesToMegaBytes(bytes) / 1024;
  return sizeInGB;
};
